import * as React from 'react';

import { usePortalUser } from 'bones/utils/portal/usePortalUser';

export interface PortalFeatures {
  voicebox: boolean;
  staticVoicebox: boolean;
}

export const defaultPortalFeatures: PortalFeatures = {
  voicebox: false,
  staticVoicebox: false,
};

export const usePortalFeatures = () => {
  const profile = usePortalUser().data;

  return React.useMemo(() => {
    const isVoiceboxEnabled = profile?.is_staff || profile?.is_voicebox_enabled;

    const isStaticVoicebox = profile?.is_static_voicebox;
    const portalFeatures: PortalFeatures = {
      voicebox: Boolean(isVoiceboxEnabled),
      staticVoicebox: Boolean(isStaticVoicebox),
    };
    return portalFeatures;
  }, [profile]);
};
